import { Mode } from '@/model';

export class InteractiveMode extends Mode {}
